<template>
  <BaseDrawer
    :is-open="isOpen"
    shrink
    @close="emit('close')"
  >
    <MoreMenuItemAction
      :icon="IconWifi"
      label="WIFI Settings"
      description="Access terminal wifi settings"
      @click="openWifiSettings"
    />
    <MoreMenuItemAction
      :icon="IconCellular"
      label="Cellular Settings"
      description="Access terminal cellular settings"
      @click="openCellularSettings"
    />
  </BaseDrawer>
</template>

<script setup lang="ts">
import { IconWifi, IconCellular } from "@/icons"
import { INetworkSettings } from "@/androidPlugins/INetworkSettings"

defineProps<{ isOpen: boolean }>()

const emit = defineEmits<{
  (eventName: "close"): void
}>()

const { openCellularSettings, openWifiSettings } =
  INetworkSettings
</script>
